/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectWithoutProperties from "/home/travis/build/moohng/wchat/node_modules/@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/travis/build/moohng/wchat/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import axios from 'axios';
import store, { types } from "../store";
var baseURL = process.env.NODE_ENV === 'production' ? 'http://39.108.137.234:30334/api/' : 'http://localhost:30600/api/';
var ax = axios.create({
  baseURL: baseURL,
  timeout: 10000
}); // window.ax = ax

var request =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(options) {
    var loading, opts, response, _response$data, code, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            loading = options.loading, opts = _objectWithoutProperties(options, ["loading"]);
            !!loading && store.commit(types.UPDATE_LOADING_STATUS, {
              loading: true
            });
            _context.prev = 2;
            _context.next = 5;
            return ax.request(opts);

          case 5:
            response = _context.sent;
            _response$data = response.data, code = _response$data.code, data = _response$data.data;

            if (!(code === 0)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", data);

          case 11:
            store.commit(types.UPDATE_INVALID_RESPONSE, {
              invalidResponse: response.data
            });
            return _context.abrupt("return", Promise.reject(response.data));

          case 13:
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", Promise.reject(_context.t0));

          case 18:
            _context.prev = 18;
            !!loading && store.commit(types.UPDATE_LOADING_STATUS, {
              loading: false
            });
            return _context.finish(18);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 15, 18, 21]]);
  }));

  return function request(_x) {
    return _ref.apply(this, arguments);
  };
}();

export var get = request.get = function (url, params, loading) {
  if (typeof params === 'boolean') {
    loading = params;
    params = undefined;
  }

  return request({
    url: url,
    loading: loading,
    params: params
  });
};
export var post = request.post = function (url, data, loading) {
  if (typeof params === 'boolean') {
    loading = data;
    data = undefined;
  }

  return request({
    url: url,
    loading: loading,
    data: data,
    method: 'post'
  });
};
export default request;